export const LINK_DISCORD = 'https://discord.com/invite/nJREqWnCyd'
